export default __webpack_public_path__ + "static/binoculars-white-a0b22407cb7ea017d1e7777ab88908e0.svg";